import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import Select from 'react-select'
import { withAuth } from '../AuthContext'
import { withSearch } from '../SearchContext'
import SingleDatePicker from '../Utils/SingleDatePicker'
import Notification from '../Utils/Notification'
import { SUCCESS } from '../../utils/constants'
import { capitalizeFirstLetter } from '../../utils/utils'
import Button from '../Utils/Button'

class EditIdentity extends Component {
  constructor(props) {
    super(props)

    const u = this.props.auth.user
    this.state = {
      user: {
        title: u.title,
        forename: u.forename,
        surname: u.surname,
        dob: u.dob,
        countryId: u.countryId,
        locationId: u.locationId,
        city: !u.locationId ? u.city : '',
        is_new_city: !u.locationId,
      },
      date: new Date(u.dob),
      cities: [],
      selectedCity: u.city_location
        ? { label: u.city_location.city, value: u.city_location.id }
        : {},
      loading: false,
      shows_verification_message: u.city,
    }

    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleTitleChange = this.handleTitleChange.bind(this)
    this.handleCountryChange = this.handleCountryChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCityChange = this.handleCityChange.bind(this)
  }

  async componentDidMount() {
    if (this.props.auth.user.user_type == 'custodian') {
      this.props.history.push('/dashboard')
    }
    await this.getCities(this.state.user.countryId)
    const selectedCity = this.state.cities.find(
      (city) => city.value === this.state.user.locationId
    )
    this.setState({ selectedCity })
  }

  handleInputChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.setState((prevState) => {
      prevState.user[name] = value
      return prevState
    })
  }

  handleTitleChange({ value }) {
    this.setState((prevState) => {
      prevState.user.title = value
      return prevState
    })
  }

  async handleCountryChange({ value }) {
    this.setState((prevState) => {
      prevState.user.countryId = value
      return prevState
    })
    await this.getCities(value)
  }

  async getCities(value) {
    try {
      const response = await axios.get(`/api/cities/${value}`)
      let cities = response.data.map((city) => {
        return { label: city.city, value: city.id }
      })
      this.setState({ cities })
    } catch (e) {
      console.log('Error getting cities: ', e)
    }
  }

  handleCityChange(option) {
    this.setState((prevState) => {
      prevState.user.locationId = option.value
      return prevState
    })
  }

  handleDateChange(date) {
    let day = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()
    const selectedDate = `${year}-${month}-${day}`
    this.setState({
      user: {
        ...this.state.user,
        dob: selectedDate,
      },
      date: date,
    })
  }

  handleSubmit(e) {
    this.setState({ loading: true })
    e.preventDefault()
    this.props.auth
      .updateUser(this.state.user)
      .then(() => {
        Notification({
          type: SUCCESS,
          message: 'Identity edited successfully',
        })

        axios
          .get('/api/verify-account-status/editidentity')
          .then(
            setTimeout(function () {
              window.open('/dashboard', '_self')
            }, 2000)
          )
          .catch((err) => {
            console.log(err)
          })
      })
      .catch((e) => {
        Notification({
          data: e,
        })
      })
      .finally(() => {
        this.setState({ loading: false })
      })
  }

  render() {
    const s = this.props.search

    const countrySelected = s.countriesNice.find(
      (c) => c.value === this.state.user.countryId
    )

    const customStyles = {
      control: (base, state) => ({
        ...base,
        background: '#ffffff',
        color: '#8d95a6',
        height: '58px',
        fontSize: '16px',
        paddingLeft: '15px',
        width: '100%',
        marginBottom: '10px',
        flexWrap: 'nowrap',
        outline: 'none',
        border: 'none',
      }),
    }

    return (
      <section className="contact-wrapper">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="contact_form">
                <h3 className="title">Edit identity</h3>
                <div id="identity">
                  <div id="message" />
                  <form
                    method="POST"
                    action="/identity"
                    name="myForm"
                    aria-label="Edit Identity"
                    onSubmit={this.handleSubmit}
                  >
                    <input
                      type="hidden"
                      name="csrf-token"
                      value={window.Laravel.csrfToken}
                    />
                    <div className="row">
                      <div className="col-12  form-group">
                        <label>Title</label>

                        <Select
                          id="title"
                          name="title"
                          styles={customStyles}
                          defaultValue={{
                            value: this.state.user.title,
                            label: this.state.user.title,
                          }}
                          isDisabled={false}
                          isLoading={false}
                          isClearable={false}
                          isRtl={false}
                          isSearchable={false}
                          options={[
                            { value: 'Mr', label: 'Mr' },
                            { value: 'Mrs', label: 'Mrs' },
                            { value: 'Ms', label: 'Ms' },
                          ]}
                          onChange={this.handleTitleChange}
                        />
                      </div>
                      <div className="col-12  form-group">
                        <label>First Name</label>
                        <input
                          className="form-control"
                          id="forename"
                          type="text"
                          name="forename"
                          required
                          autoFocus
                          value={this.state.user.forename}
                          onChange={this.handleInputChange}
                        />
                      </div>
                      <div className="col-12  form-group">
                        <label>Second Name</label>
                        <input
                          className="form-control"
                          id="surname"
                          type="text"
                          name="surname"
                          required
                          autoFocus
                          value={this.state.user.surname}
                          onChange={this.handleInputChange}
                        />
                      </div>
                      <div className="col-12  form-group">
                        <label>Date of Birth</label>

                        <SingleDatePicker
                          value={this.state.date}
                          selected={this.state.date}
                          onChange={this.handleDateChange}
                        />
                      </div>

                      <div className="col-12  form-group">
                        <label>Country</label>
                        <Select
                          id="country"
                          name="country"
                          styles={customStyles}
                          value={countrySelected}
                          isDisabled={false}
                          isLoading={false}
                          isClearable={false}
                          isRtl={false}
                          isSearchable={true}
                          required
                          options={s.countriesNice}
                          onChange={this.handleCountryChange}
                        />
                      </div>

                      {!this.state.user.is_new_city ? (
                        <div className="col-12  form-group">
                          <label>City</label>
                          <Select
                            id="city"
                            name="city"
                            styles={customStyles}
                            isDisabled={false}
                            isLoading={false}
                            isClearable={false}
                            isRtl={false}
                            isSearchable={true}
                            options={this.state.cities}
                            required
                            onChange={this.handleCityChange}
                            defaultValue={this.state.selectedCity}
                          />
                        </div>
                      ) : (
                        <div className="col-12  form-group">
                          <label>
                            Type your city/town{' '}
                            {this.state.shows_verification_message && (
                              <span style={{ color: 'red' }}>
                                (pending verification)
                              </span>
                            )}
                          </label>
                          <input
                            className="form-control"
                            placeholder="Enter town/city then press enter"
                            id="city"
                            type="text"
                            name="city"
                            value={capitalizeFirstLetter(this.state.user.city)}
                            onChange={this.handleInputChange}
                          />
                        </div>
                      )}

                      <div className="col-12  form-group">
                        <div className="form-check">
                          <label className="form-check-label">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="is_new_city"
                              checked={this.state.user.is_new_city}
                              onChange={this.handleInputChange}
                            />
                            City/Town not listed
                          </label>
                        </div>
                      </div>

                      <div className="btn-toolbar">
                        <div className="submit-btn">
                          <Button
                            type="submit"
                            color="primary"
                            icon="fa fa-save"
                            loading={this.state.loading}
                          >
                            Upload
                          </Button>
                          <Link
                            to="/dashboard"
                            className="btn btn-warning text-decoration-none ml-2"
                          >
                            Return
                          </Link>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withRouter(withSearch(withAuth(EditIdentity)))
